export const productShortName = 'Vino ed Enologia — Edizione Professionale';
export const productBrand = 'Vino ed Enologia';
export const productEdition = 'Edizione Professionale';
export const productImage = 'https://cdn.magicpatterns.com/uploads/eRwjUm3RyrRg82WD5kJESo/MOCKUP_VINO.png';
export const productImageAlt =
  'Vino ed Enologia Edizione Professionale: collezione completa in 6 volumi con cofanetto, 5 bonus, tablet con la ruota degli aromi, calice di vino rosso e grappolo d’uva';

export const checkoutUrl = 'https://vino-enologia-professionale.impultienda.ar/checkout';

export const price = '€27';
export const priceBefore = '€80';

export const totalVolumes = 6;
export const totalBonuses = 5;
export const bonusValue = '€17';
export const bonusTotalValue = '€85';

export const assurances = ['Pagamento sicuro', 'Accesso immediato', 'Garanzia di 7 giorni'];

export const closingLines = [
  'Basta imparare il vino a pezzi da fonti sparse',
  'Basta etichette e carte dei vini incomprensibili',
  'Basta abbinamenti fatti a caso',
  'Basta degustare senza un metodo',
  'Basta sentirti insicuro quando si parla di vino',
];
